import script from "./enzrjs.vue?vue&type=script&setup=true&lang=js"
export * from "./enzrjs.vue?vue&type=script&setup=true&lang=js"

import "./enzrjs.vue?vue&type=style&index=0&id=ca27374a&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca27374a"]])

export default __exports__